// Dashboard Events evolution page translations (pt-BR), loaded into dashboard.events.evolution by ../pt-BR.events.js
module.exports = {
  menu: "Evolução",
  title: "Evolução de Eventos",
  description: "Eventos criados, ativos e interações por {gran}.",
  panels: {
    newEvents: "Novos eventos por {gran}",
    active: "Eventos ativos (média) por {gran}",
    windows: "Novos eventos — este período vs. anteriores",
    windowsNote: "Cada barra tem a mesma duração do período selecionado.",
    weekday: "Cliques por dia da semana (média)",
    interactions: "Interações por {gran}",
  },
  hints: {
    shorterThan7: "n/d — período inferior a 7 dias",
  },
  series: {
    promoted: "Divulgados",
    clicks: "Cliques",
    shared: "Partilhados",
  },
  weekdays: {
    mon: "Segunda-feira",
    tue: "Terça-feira",
    wed: "Quarta-feira",
    thu: "Quinta-feira",
    fri: "Sexta-feira",
    sat: "Sábado",
    sun: "Domingo",
  },
  weekdaysShort: {
    mon: "Seg",
    tue: "Ter",
    wed: "Qua",
    thu: "Qui",
    fri: "Sex",
    sat: "Sáb",
    sun: "Dom",
  },
  panelInfo: {
    newEvents: "Eventos criados em cada intervalo.\nFonte: Firebase (contadores de eventos).",
    active: "Média de eventos ativos a decorrer por dia em cada intervalo.\nFonte: Firebase (eventos).",
    windows: "Eventos criados neste período e nos anteriores de igual duração.\nFonte: Firebase (contadores de eventos).",
    weekday: "Média de cliques em links de eventos em cada dia da semana no período.\nFonte: Firebase (contadores de eventos).",
    interactions: "Eventos divulgados, partilhados e cliques em links em cada intervalo.\nFonte: Firebase (contadores de eventos).",
  },
};
